import React, { useMemo } from 'react';

// Generates the subtle ASCII/character noise like emergent.sh background
export default function BackgroundPattern({ className = '' }) {
  const rows = useMemo(() => {
    const chars = 'NHSXOQGUVPMLKJDTRABCY+,.-=*'.split('');
    const lines = [];
    for (let i = 0; i < 60; i++) {
      let line = '';
      for (let j = 0; j < 180; j++) {
        line += Math.random() < 0.55 ? chars[Math.floor(Math.random() * chars.length)] : ' ';
      }
      lines.push(line);
    }
    return lines;
  }, []);

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden select-none ${className}`}
      style={{
        fontFamily: 'JetBrains Mono, monospace',
        fontSize: '13px',
        lineHeight: '20px',
        color: 'rgba(0,0,0,0.06)',
        whiteSpace: 'pre',
        letterSpacing: '4px',
      }}
    >
      {rows.map((r, i) => (
        <div key={i}>{r}</div>
      ))}
    </div>
  );
}
